<template>
    <div
        class="estimate-preview invoice preview"
        :class="{
          'branding-type1': isVendorBrandingType1,
          'branding-type2': isVendorBrandingType2,
          'branding-type3': isVendorBrandingType3,
        'estimate-preview-mobile': isMobile,
        }"
    >
      <table v-if="isVendorBrandingType1" class="table b-table table-preview rs-scroll rs-scroll--y">
        <tr class="nobrd">
          <td colspan="7">
            <div class="preview-logo"><img :src="vendorInfo.logo" style="height: 150px; width: 300px;" alt=""></div>
          </td>
          <td colspan="3">
            <div class="preview-header">
              <div class="preview-header-title">ESTIMATE</div>
              <div class="preview-header-business-name">{{estimateTo.vendor.business_name}}</div>
              <div class="preview-header-item"><span class="preview-header-item-name">ABN:</span> <span class="preview-header-item-value">{{estimateTo.vendor.abn}}</span>
              </div>
              <div class="preview-header-delimiter"></div>
              <div class="preview-header-item"><span class="preview-header-item-name">Estimate Number: </span>
                <span v-if="estimateTo.estimate.supplement_number > 0" class="preview-header-item-value"> {{estimateTo.estimate.estimate_number}} - {{estimateTo.estimate.supplement_number}}</span>
                <span v-else class="preview-header-item-value">{{estimateTo.estimate.estimate_number}}</span>
              </div>
              <div v-if="!isVendorBrandingType1" class="preview-header-item"><span class="preview-header-item-name">Estimator:</span> <span class="preview-header-item-value">{{estimateTo.estimate.estimator}}</span>
              </div>
              <div class="preview-header-item"><span class="preview-header-item-name">Date:</span> <span class="preview-header-item-value">{{estimateTo.estimate.created_on}}</span>
              </div>
              <div class="preview-header-item"><span class="preview-header-item-name">Expiry:</span> <span class="preview-header-item-value">{{estimateTo.estimate.expires_on}}</span>
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="!isVendorBrandingType2" class="nobrd">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr  v-if="!isVendorBrandingType2" class="nobrd">
        </tr>
        <tr v-if="!isVendorBrandingType2" class="nobrd">
          <td colspan="4">
            <div class="preview-subhead-name">Customer</div>
          </td>
          <td colspan="6">
            <div class="preview-subhead-name">Vehicle</div>
          </td>
        </tr>
        <tr v-if="!isVendorBrandingType2" class="nobrd">
          <td colspan="4">
            <table>
              <tr class="nobrd">
                <td class="w-25"></td>
                <td class="w-25"></td>
                <td class="w-25"></td>
                <td class="w-25"></td>
              </tr>
              <tr class="nobrd">
                <td>
                  <div class="preview-item-name">Owner Name:</div>
                </td>
                <td colspan="3">
                  <div class="preview-item-value">{{estimateTo.customer.customer_name}}</div>
                </td>
              </tr>
              <tr class="nobrd">
                <td>
                  <div class="preview-item-name">Home Phone:</div>
                </td>
                <td colspan="3">
                  <div class="preview-item-value">{{estimateTo.customer.phone}}</div>
                </td>
              </tr>
              <tr class="nobrd">
                <td>
                  <div class="preview-item-name">Mobile Phone:</div>
                </td>
                <td colspan="3">
                  <div class="preview-item-value">{{estimateTo.customer.mobile}}</div>
                </td>
              </tr>
              <tr class="nobrd">
                <td>
                  <div class="preview-item-name">Email:</div>
                </td>
                <td colspan="3">
                  <div class="preview-item-value">{{estimateTo.customer.email}}</div>
                </td>
              </tr>
              <tr class="nobrd" v-if="estimateTo.customer.customer_type == 'B'">
                <td>
                  <div class="preview-item-name">ABN:</div>
                </td>
                <td colspan="3">
                  <div class="preview-item-value">{{estimateTo.customer.abn}}</div>
                </td>
              </tr>
            </table>
          </td>
          <td colspan="6">
            <table class="nobrd">
              <tr>
                <td class="w-50">
                  <table class="nobrd">
                    <tr>
                      <td class="w-33"></td>
                      <td class="w-33"></td>
                      <td class="w-33"></td>
                    </tr>
                    <tr>
                      <td>
                        <div class="preview-item-name">Make:</div>
                      </td>
                      <td colspan="2">
                        <div class="preview-item-value">{{estimateTo.customer_vehicle.make}}</div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="preview-item-name">Model:</div>
                      </td>
                      <td colspan="2">
                        <div class="preview-item-value">{{estimateTo.customer_vehicle.model}}</div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="preview-item-name">Series:</div>
                      </td>
                      <td colspan="2">
                        <div v-if="estimateTo && estimateTo.properties && estimateTo.properties.isHideSeries && estimateTo.properties.isHideSeries === true"
                             class="preview-item-value"> </div>
                        <div v-else class="preview-item-value">{{estimateTo.customer_vehicle.series}}</div>
                      </td>
                    </tr>
                  </table>
                </td>
                <td class="w-50">
                  <table class="nobrd">
                    <tr>
                      <td class="w-33"></td>
                      <td class="w-33"></td>
                      <td class="w-33"></td>
                    </tr>
                    <tr>
                      <td>
                        <div class="preview-item-name">Rego:</div>
                      </td>
                      <td colspan="2">
                        <div class="preview-item-value">{{estimateTo.customer_vehicle.rego_number}}</div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr  class="nobrd">
          <td colspan="10">
            <div class="preview-delimiter"></div>
          </td>
        </tr>
        <!--
         RR with hours
        -->
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] !=''">
          <td colspan="6">
            <div class="preview-subhead-name">R&R</div>
          </td>
          <td>
            <div class="preview-subhead-name">
              <span v-if="isEstimateMethodologyDollar"></span>
              <span v-else>Hrs</span>
            </div>
          </td>
          <td>
            <div class="preview-subhead-name">
              <span v-if="isEstimateMethodologyDollar"></span>
              <span v-else>Rate</span>
            </div>
          </td>
          <td>
            <div class="preview-subhead-name"></div>
          </td>
          <td>
            <div class="preview-subhead-name preview-amount-header">Amount</div>
          </td>
        </tr>
        <tr v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] !=''"
            v-for="line in estimateTo.line_items.lines.RR">
          <td colspan="6">
            <div class="preview-item-name">{{line.name}}
              <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                Comment: <span>{{line.manual_pdf_comment}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="preview-item-value">
              <span v-if="isEstimateMethodologyDollar || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
              <span v-else>{{line.hrs_str}}</span>
            </div>
          </td>
          <td>
            <div class="preview-item-value">
              <span v-if="isEstimateMethodologyDollar"></span>
              <span v-else>{{line.rate_str}}</span>
            </div>
          </td>
          <td>
            <div class="preview-item-value"></div>
          </td>
          <td>
            <div class="preview-item-value preview-amount">{{line.total_str}}</div>
          </td>
        </tr>
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] !=''">
          <td colspan="6">
            <div class="preview-item-name preview-align-right">Subtotal Hrs</div>
          </td>
          <td>
            <div class="preview-item-name">{{estimateTo.line_items.summary["RR-Hrs-SubTotal-Str"]}}</div>
          </td>
          <td>
            <div class="preview-item-value"></div>
          </td>
          <td>
            <div class="preview-item-name preview-align-right">Subtotal</div>
          </td>
          <td>
            <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["RR-Total-SubTotal-Str"]}}</div>
          </td>
        </tr>
        <!--
        RR without hours
       -->
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] ==''">
          <td colspan="9">
            <div class="preview-subhead-name">R&R</div>
          </td>
          <td>
            <div class="preview-subhead-name preview-amount-header">Amount</div>
          </td>
        </tr>
        <tr v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] ==''"
            v-for="line in estimateTo.line_items.lines.RR">
          <td colspan="9">
            <div class="preview-item-name">{{line.name}}
              <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                Comment: <span>{{line.manual_pdf_comment}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="preview-item-value">{{line.total_str}}</div>
          </td>
        </tr>
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] ==''">
          <td colspan="9">
            <div class="preview-item-name preview-align-right">Subtotal</div>
          </td>
          <td>
            <div class="preview-item-name  preview-amount">{{estimateTo.line_items.summary["RR-Total-SubTotal-Str"]}}</div>
          </td>
        </tr>
        <!--
       Delimiter
      -->
        <tr class="nobrd">
          <td colspan="10">
            <div class="preview-delimiter"></div>
          </td>
        </tr>
        <!--
         Repair with hours
        -->
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] !=''">
          <td colspan="6">
            <div class="preview-subhead-name">Repair</div>
          </td>
          <td>
            <div class="preview-subhead-name">
              <span v-if="isEstimateMethodologyDollar"></span>
              <span v-else>Hrs</span>
            </div>
          </td>
          <td>
            <div class="preview-subhead-name">
              <span v-if="isEstimateMethodologyDollar"></span>
              <span v-else>Rate</span>
            </div>
          </td>
          <td>
            <div class="preview-subhead-name"></div>
          </td>
          <td>
            <div class="preview-subhead-name preview-amount-header">Amount</div>
          </td>
        </tr>
        <tr v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] !=''"
            v-for="line in estimateTo.line_items.lines.Repair">
          <td colspan="6">
            <div class="preview-item-name">{{line.name}}
              <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                Comment: <span>{{line.manual_pdf_comment}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="preview-item-value">
              <span v-if="isEstimateMethodologyDollar || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
              <span v-else>{{line.hrs_str}}</span>
            </div>
          </td>
          <td>
            <div class="preview-item-value">
              <span v-if="isEstimateMethodologyDollar || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
              <span v-else>{{line.rate_str}}</span>
            </div>
          </td>
          <td>
            <div class="preview-item-value"></div>
          </td>
          <td>
            <div class="preview-item-value preview-amount">{{line.total_str}}</div>
          </td>
        </tr>
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] !=''">
          <td colspan="6">
            <div class="preview-item-name preview-align-right">Subtotal Hrs</div>
          </td>
          <td>
            <div class="preview-item-name">{{estimateTo.line_items.summary["Repair-Hrs-SubTotal-Str"]}}</div>
          </td>
          <td>
            <div class="preview-item-value"></div>
          </td>
          <td>
            <div class="preview-item-name preview-align-right">Subtotal</div>
          </td>
          <td>
            <div class="preview-item-name  preview-amount">{{estimateTo.line_items.summary["Repair-Total-SubTotal-Str"]}}</div>
          </td>
        </tr>
        <!--
        Repair without hours
         -->
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] ==''">
          <td colspan="9">
            <div class="preview-subhead-name">Repair</div>
          </td>
          <td>
            <div class="preview-subhead-name preview-amount-header">Amount</div>
          </td>
        </tr>
        <tr v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] ==''"
            v-for="line in estimateTo.line_items.lines.Repair">
          <td colspan="9">
            <div class="preview-item-name">{{line.name}}
              <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                Comment: <span>{{line.manual_pdf_comment}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="preview-item-value preview-amount">{{line.total_str}}</div>
          </td>
        </tr>
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] ==''">
          <td colspan="9">
            <div class="preview-item-name preview-align-right">Subtotal</div>
          </td>
          <td>
            <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Repair-Total-SubTotal-Str"]}}</div>
          </td>
        </tr>
        <!--
       Delimiter
      -->
        <tr v-if="!!estimateTo.line_items.lines.Repair.length" class="nobrd">
          <td colspan="10">
            <div class="preview-delimiter"></div>
          </td>
        </tr>
        <!--
                                       Paint with hours
                                       -->
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] !=''">
          <td colspan="6">
            <div class="preview-subhead-name">Paint</div>
          </td>
          <td>
            <div class="preview-subhead-name">
              <span v-if="isEstimateMethodologyDollar"></span>
              <span v-else>Hrs</span>
            </div>
          </td>
          <td>
            <div class="preview-subhead-name">
              <span v-if="isEstimateMethodologyDollar"></span>
              <span v-else>Rate</span>
            </div>
          </td>
          <td>
            <div class="preview-subhead-name"></div>
          </td>
          <td>
            <div class="preview-subhead-name preview-amount-header">Amount</div>
          </td>
        </tr>
        <tr v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] !=''"
            v-for="line in estimateTo.line_items.lines.Paint">
          <td colspan="6">
            <div class="preview-item-name">{{line.name}}
              <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                Comment: <span>{{line.manual_pdf_comment}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="preview-item-value">
              <span v-if="isEstimateMethodologyDollar || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
              <span v-else>{{line.hrs_str}}</span>
            </div>
          </td>
          <td>
            <div class="preview-item-value">
              <span v-if="isEstimateMethodologyDollar || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
              <span v-else>{{line.rate_str}}</span>
            </div>
          </td>
          <td>
            <div class="preview-item-value"></div>
          </td>
          <td>
            <div class="preview-item-value preview-amount">{{line.total_str}}</div>
          </td>
        </tr>
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] !=''">
          <td colspan="6">
            <div class="preview-item-name preview-align-right">Subtotal Hrs</div>
          </td>
          <td>
            <div class="preview-item-name">{{estimateTo.line_items.summary["Paint-Hrs-SubTotal-Str"]}}</div>
          </td>
          <td>
            <div class="preview-item-value"></div>
          </td>
          <td>
            <div class="preview-item-name preview-align-right">Subtotal</div>
          </td>
          <td>
            <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Paint-Total-SubTotal-Str"]}}</div>
          </td>
        </tr>
        <!--
                                        Paint without hours
                                         -->
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] ==''">
          <td colspan="9">
            <div class="preview-subhead-name">Paint</div>
          </td>
          <td>
            <div class="preview-subhead-name preview-amount-header">Amount</div>
          </td>
        </tr>
        <tr v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] ==''"
            v-for="line in estimateTo.line_items.lines.Paint">
          <td colspan="9">
            <div class="preview-item-name">{{line.name}}
              <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                Comment: <span>{{line.manual_pdf_comment}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="preview-item-value preview-amount">{{line.total_str}}</div>
          </td>
        </tr>
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] ==''">
          <td colspan="9">
            <div class="preview-item-name preview-align-right">Subtotal</div>
          </td>
          <td>
            <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Paint-Total-SubTotal-Str"]}}</div>
          </td>
        </tr>
        <!--
        Labour
        -->
        <tr class="nobrd"
            v-if="(!!estimateTo.line_items.lines.Paint.length || !!estimateTo.line_items.lines.Repair.length || !!estimateTo.line_items.lines.RR.length) && estimateTo.line_items.summary['Labour-Hrs-Str'] != ''">
          <td colspan="6">
            <div class="preview-item-name preview-align-right">Total Labour Hours</div>
          </td>
          <td>
            <div class="preview-item-name">{{estimateTo.line_items.summary["Labour-Hrs-Str"]}}</div>
          </td>
          <td>
            <div class="preview-item-value"></div>
          </td>
          <td>
            <div class="preview-item-name preview-align-right">Subtotal Amount</div>
          </td>
          <td>
            <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Labour-Cost-Str"]}}</div>
          </td>
        </tr>
        <tr class="nobrd"
            v-if="(!!estimateTo.line_items.lines.Paint.length || !!estimateTo.line_items.lines.Repair.length || !!estimateTo.line_items.lines.RR.length) && estimateTo.line_items.summary['Labour-Hrs-Str'] == ''">
          <td colspan="9">
            <div class="preview-item-name preview-align-right">Subtotal Amount</div>
          </td>
          <td>
            <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Labour-Cost-Str"]}}</div>
          </td>
        </tr>
        <!--
       Delimiter
      -->
        <tr v-if="!!estimateTo.line_items.lines.Paint.length" class="nobrd">
          <td colspan="10">
            <div class="preview-delimiter"></div>
          </td>
        </tr>
        <!--
         Parts
        -->
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Part.length">
          <td colspan="5">
            <div class="preview-subhead-name">Parts</div>
          </td>
          <td>
            <div class="preview-subhead-name">Part No</div>
          </td>
          <td>
            <div class="preview-subhead-name">Qty</div>
          </td>
          <td>
            <div class="preview-subhead-name preview-subhead-unit-price">Unit Price</div>
          </td>
          <td>
            <div class="preview-subhead-name"></div>
          </td>
          <td>
            <div class="preview-subhead-name preview-amount-header">Amount</div>
          </td>
        </tr>
        <tr v-if="!!estimateTo.line_items.lines.Part.length" v-for="line in estimateTo.line_items.lines.Part">
          <td colspan="5">
            <div class="preview-item-name">{{line.name}}
              <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                Comment: <span>{{line.manual_pdf_comment}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="preview-item-value">{{line.part_num}}</div>
          </td>
          <td>
            <div class="preview-item-value">{{line.qty}}</div>
          </td>
          <td>
            <div class="preview-item-value">{{line.rate_str}}</div>
          </td>
          <td>
            <div class="preview-item-value"></div>
          </td>
          <td>
            <div class="preview-item-value preview-amount">{{line.total_str}}</div>
          </td>
        </tr>
        <tr v-if="!!estimateTo.line_items.lines.Part.length" class="nobrd">
          <td colspan="9">
            <div class="preview-item-name preview-align-right">Subtotal</div>
          </td>
          <td>
            <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Part-Total-SubTotal-Str"]}}</div>
          </td>
        </tr>
        <!--
        Delimiter
        -->
        <tr v-if="!!estimateTo.line_items.lines.Part.length" class="nobrd">
          <td colspan="10">
            <div class="preview-delimiter"></div>
          </td>
        </tr>
        <!--
        PDR
        -->
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.PDR.length">
          <td colspan="5">
            <div class="preview-subhead-name">PDR</div>
          </td>
          <td>
            <div class="preview-subhead-name">Material</div>
          </td>
          <td>
            <div class="preview-subhead-name">Action</div>
          </td>
          <td>
            <div class="preview-subhead-name">Qty</div>
          </td>
          <td>
            <div class="preview-subhead-name">Price</div>
          </td>
          <td>
            <div class="preview-subhead-name preview-amount-header">Amount</div>
          </td>
        </tr>
        <tr v-if="!!estimateTo.line_items.lines.PDR.length" v-for="line in estimateTo.line_items.lines.PDR">
          <td colspan="5">
            <div class="preview-item-name">{{line.name}}
              <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                Comment: <span>{{line.manual_pdf_comment}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="preview-item-value">{{line.type === 'panel' ? line.material : ''}}</div>
          </td>
          <td>
            <div class="preview-item-value">{{line.type === 'panel' ? line.action : ''}}</div>
          </td>
          <td>
            <div class="preview-item-value">{{line.qty}}</div>
          </td>
          <td>
            <div class="preview-item-value">{{line.price}}</div>
          </td>
          <td>
            <div class="preview-item-value preview-amount">{{line.total_str}}</div>
          </td>
        </tr>
        <tr v-if="!!estimateTo.line_items.lines.PDR.length" class="nobrd">
          <td colspan="9">
            <div class="preview-item-name preview-align-right">Subtotal</div>
          </td>
          <td>
            <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["PDR-Total-SubTotal-Str"]}}</div>
          </td>
        </tr>
        <!--
        Delimiter
        -->
        <tr v-if="!!estimateTo.line_items.lines.PDR.length" class="nobrd">
          <td colspan="10">
            <div class="preview-delimiter"></div>
          </td>
        </tr>
        <!--
        Materials
                -->
        <tr v-if="!!estimateTo.line_items.lines.Materials.length" class="nobrd">
          <td colspan="7">
            <div class="preview-subhead-name">Materials</div>
          </td>
          <td>
            <div class="preview-subhead-name">Hrs</div>
          </td>
          <td>
            <div class="preview-subhead-name"></div>
          </td>
          <td>
            <div class="preview-subhead-name preview-amount-header">Amount</div>
          </td>
        </tr>
        <tr v-if="!!estimateTo.line_items.lines.Materials.length" v-for="line in estimateTo.line_items.lines.Materials">
          <td colspan="7">
            <div class="preview-item-name">{{line.name}}
              <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                Comment: <span>{{line.manual_pdf_comment}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="preview-item-value">{{line.hrs_str}}</div>
          </td>
          <td>
            <div class="preview-item-value"></div>
          </td>
          <td>
            <div class="preview-item-value preview-amount">{{line.total_str}}</div>
          </td>
        </tr>
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Materials.length">
          <td colspan="9">
            <div class="preview-item-name preview-align-right">Subtotal</div>
          </td>
          <td>
            <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Materials-Total-Str"]}}</div>
          </td>
        </tr>
        <!--
        Delimiter
        -->
        <tr v-if="!!estimateTo.line_items.lines.Materials.length" class="nobrd">
          <td colspan="10">
            <div class="preview-delimiter"></div>
          </td>
        </tr>
        <!--
        Sublet with Hrs
       -->
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Sublet.length && estimateTo.line_items.summary['Sublet-Hrs-SubTotal-Str'] !=''">
          <td colspan="5">
            <div class="preview-subhead-name">Sublet</div>
          </td>
          <td>
            <div class="preview-subhead-name">Repairer</div>
          </td>
          <td>
            <div class="preview-subhead-name">Hrs</div>
          </td>
          <td>
            <div class="preview-subhead-name">Rate</div>
          </td>
          <td>
            <div class="preview-subhead-name"></div>
          </td>
          <td>
            <div class="preview-subhead-name preview-amount-header">Amount</div>
          </td>
        </tr>
        <tr v-if="!!estimateTo.line_items.lines.Sublet.length && estimateTo.line_items.summary['Sublet-Hrs-SubTotal-Str'] !=''"
            v-for="line in estimateTo.line_items.lines.Sublet">
          <td colspan="5">
            <div class="preview-item-name">{{line.name}}
              <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                Comment: <span>{{line.manual_pdf_comment}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="preview-item-value">{{line.repairer}}</div>
          </td>
          <td>
            <div class="preview-item-value">{{line.hrs_str}}</div>
          </td>
          <td>
            <div class="preview-item-value">{{line.rate_str}}</div>
          </td>
          <td>
            <div class="preview-item-value"></div>
          </td>
          <td>
            <div class="preview-item-value preview-amount">{{line.total_str}}</div>
          </td>
        </tr>
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Sublet.length && estimateTo.line_items.summary['Sublet-Hrs-SubTotal-Str'] != ''">
          <td colspan="7">
            <div class="preview-item-name preview-align-right">Subtotal Hrs</div>
          </td>
          <td>
            <div class="preview-item-name preview-align-right">{{estimateTo.line_items.summary["Sublet-Hrs-SubTotal-Str"]}}</div>
          </td>
          <td>
            <div class="preview-item-name preview-align-right">Subtotal</div>
          </td>
          <td>
            <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Sublet-Total-SubTotal-Str"]}}</div>
          </td>
        </tr>
        <!--
       Sublet without Hrs
      -->
        <tr v-if="!!estimateTo.line_items.lines.Sublet.length && estimateTo.line_items.summary['Sublet-Hrs-SubTotal-Str'] ==''" class="nobrd">
          <td colspan="5">
            <div class="preview-subhead-name">Sublet</div>
          </td>
          <td>
            <div class="preview-subhead-name">Repairer</div>
          </td>
          <td>
            <div class="preview-subhead-name"></div>
          </td>
          <td>
            <div class="preview-subhead-name"></div>
          </td>
          <td>
            <div class="preview-subhead-name"></div>
          </td>
          <td>
            <div class="preview-subhead-name preview-amount-header">Amount</div>
          </td>
        </tr>
        <tr v-if="!!estimateTo.line_items.lines.Sublet.length && estimateTo.line_items.summary['Sublet-Hrs-SubTotal-Str'] ==''"
            v-for="line in estimateTo.line_items.lines.Sublet">
          <td colspan="5">
            <div class="preview-item-name">{{line.name}}
              <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                Comment: <span>{{line.manual_pdf_comment}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="preview-item-value">{{line.repairer}}</div>
          </td>
          <td>
            <div class="preview-item-value"></div>
          </td>
          <td>
            <div class="preview-item-value"></div>
          </td>
          <td>
            <div class="preview-item-value"></div>
          </td>
          <td>
            <div class="preview-item-value preview-amount">{{line.total_str}}</div>
          </td>
        </tr>
        <tr v-if="!!estimateTo.line_items.lines.Sublet.length && estimateTo.line_items.summary['Sublet-Hrs-SubTotal-Str'] == ''" class="nobrd">
          <td colspan="9">
            <div class="preview-item-name preview-align-right">Subtotal</div>
          </td>
          <td>
            <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Sublet-Total-SubTotal-Str"]}}</div>
          </td>
        </tr>
        <!--
       Delimiter
      -->
        <tr v-if="!!estimateTo.line_items.lines.Sublet.length" class="nobrd">
          <td colspan="10">
            <div class="preview-delimiter"></div>
          </td>
        </tr>
        <!--
         Other
        -->
        <tr v-if="!!estimateTo.line_items.lines.Other.length" class="nobrd">
          <td colspan="9">
            <div class="preview-subhead-name">
              <template v-if="isVendorBrandingType2">Item</template>
              <template v-else-if="isVendorBrandingType3">Description</template>
              <template v-else>Other</template>
            </div>
          </td>
          <td>
            <div class="preview-subhead-name preview-amount-header">Amount</div>
          </td>
        </tr>
        <tr v-if="!!estimateTo.line_items.lines.Other.length" v-for="line in estimateTo.line_items.lines.Other">
          <td colspan="9">
            <div class="preview-item-name">{{line.name}}
              <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                Comment: <span>{{line.manual_pdf_comment}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="preview-item-value preview-amount">{{line.total_str}}</div>
          </td>
        </tr>
        <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Other.length">
          <td colspan="9">
            <div class="preview-item-name preview-align-right">Subtotal</div>
          </td>
          <td>
            <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Other-Total-SubTotal-Str"]}}</div>
          </td>
        </tr>
        <!--
       Delimiter
      -->
        <tr v-if="!!estimateTo.line_items.lines.Other.length" class="nobrd">
          <td colspan="10">
            <div class="preview-delimiter"></div>
          </td>
        </tr>
        <!--
        Total
        -->
        <tr v-if="countSubtotal > 1" class="nobrd">
          <td colspan="9">
            <div class="preview-item-name preview-align-right">Total</div>
          </td>
          <td>
            <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Total_str"]}}</div>
          </td>
        </tr>
        <tr class="nobrd">
          <td colspan="9">
            <div class="preview-item-name preview-align-right">GST</div>
          </td>
          <td>
            <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary.GST_str}}</div>
          </td>
        </tr>
        <tr class="nobrd">
          <td colspan="8">
            <div class="preview-item-name preview-align-right"></div>
          </td>
          <td colspan="">
            <div class="preview-item-name preview-align-right"
                 style="border-top: 1px solid rgba(27, 30, 56, 0.25) !important;margin-left: 45px; padding-left: 0px;
">Total Inc GST
            </div>
          </td>
          <td>
            <div class="preview-item-name preview-amount"
                 style="border-top:1px solid rgba(27,30,56,0.25) !important; position: relative;"
            >{{estimateTo.line_items.summary.GrandTotal_str}}
              <div class="preview-total-plus"></div>
            </div>

          </td>
        </tr>
        <tr class="nobrd">
          <td colspan="10">
            <div class="preview-terms-delimeter"></div>
          </td>
        </tr>
        <tr class="nobrd">
          <td colspan="10">
            <div class="preview-terms-header">Terms</div>
          </td>
        </tr>
        <tr class="nobrd">
          <td colspan="10">
            <div class="preview-terms" v-html="estimateTo.terms"></div>
          </td>
        </tr>

      </table>

      <table v-else-if="!isMobile" class="table b-table table-preview rs-scroll rs-scroll--y">
            <tr class="nobrd">
                <td colspan="7">
                    <div class="preview-logo"><img :src="vendorInfo.logo" style="height: 225px; width: 450px;" alt=""></div>
                </td>
                <td colspan="2">
                    <div class="preview-header">
                        <div class="preview-header-title">ESTIMATE</div>
                        <div class="preview-header-business-name">{{estimateTo.vendor.business_name}}</div>
                        <div class="preview-header-item"><span class="preview-header-item-name">ABN:</span> <span class="preview-header-item-value">{{estimateTo.vendor.abn}}</span>
                        </div>
                        <div class="preview-header-item"><span class="preview-header-item-name">License:</span> <span
                                class="preview-header-item-value">{{estimateTo.vendor.license_number}}</span>
                        </div>
                        <div class="preview-header-item" v-if="estimateTo.vendor.postal_address"><span class="preview-header-item-value">{{estimateTo.vendor.postal_address}}</span>
                        </div>
                        <div class="preview-header-item" v-if="!estimateTo.vendor.postal_address"><span class="preview-header-item-value">{{estimateTo.vendor.postal_street}} {{estimateTo.vendor.postal_suburb}}</span>
                        </div>
                        <div class="preview-header-item" v-if="!estimateTo.vendor.postal_address"><span class="preview-header-item-value">{{estimateTo.vendor.postal_state}} {{estimateTo.vendor.postal_country}}</span>
                        </div>
                        <div class="preview-header-item"><span class="preview-header-item-name">Email:</span> <span class="preview-header-item-value">{{estimateTo.vendor.email}}</span>
                        </div>
                        <div class="preview-header-item"><span class="preview-header-item-name">Phone:</span> <span class="preview-header-item-value">{{estimateTo.vendor.phone_area_code}} {{estimateTo.vendor.phone}}</span>
                        </div>
                        <div class="preview-header-delimiter"></div>
                        <div class="preview-header-item"><span class="preview-header-item-name">Estimate Number: </span>
                          <span v-if="estimateTo.estimate.supplement_number > 0" class="preview-header-item-value"> {{estimateTo.estimate.estimate_number}} - {{estimateTo.estimate.supplement_number}}</span>
                          <span v-else class="preview-header-item-value">{{estimateTo.estimate.estimate_number}}</span>
                        </div>
                        <div v-if="!isVendorBrandingType1" class="preview-header-item"><span class="preview-header-item-name">Estimator:</span> <span class="preview-header-item-value">{{estimateTo.estimate.estimator}}</span>
                        </div>
                        <div class="preview-header-item"><span class="preview-header-item-name">Date:</span> <span class="preview-header-item-value">{{estimateTo.estimate.created_on}}</span>
                        </div>
                        <div class="preview-header-item"><span class="preview-header-item-name">Expiry:</span> <span class="preview-header-item-value">{{estimateTo.estimate.expires_on}}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr v-if="!isVendorBrandingType2" class="nobrd">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr  class="nobrd">
                <td colspan="9">
                    <div class="preview-head-name">Vehicle & Owner</div>
                </td>
            </tr>
            <tr class="nobrd">
                <td colspan="4">
                    <div class="preview-subhead-name">Owner Detail</div>
                </td>
                <td colspan="5">
                    <div class="preview-subhead-name">Vehicle Detail</div>
                </td>
            </tr>
            <tr  class="nobrd">
                <td colspan="4">
                    <table>
                        <tr class="nobrd">
                            <td class="w-25"></td>
                            <td class="w-25"></td>
                            <td class="w-25"></td>
                            <td class="w-25"></td>
                        </tr>
                        <tr class="nobrd">
                            <td>
                                <div class="preview-item-name" style="min-width: 114px;">Owner Name:</div>
                            </td>
                            <td colspan="3">
                                <div class="preview-item-value">{{estimateTo.customer.customer_name}}</div>
                            </td>
                        </tr>
                        <tr class="nobrd">
                            <td>
                                <div class="preview-item-name">Home Phone:</div>
                            </td>
                            <td colspan="3">
                                <div class="preview-item-value">{{estimateTo.customer.phone}}</div>
                            </td>
                        </tr>
                        <tr class="nobrd">
                            <td>
                                <div class="preview-item-name">Mobile Phone:</div>
                            </td>
                            <td colspan="3">
                                <div class="preview-item-value">{{estimateTo.customer.mobile}}</div>
                            </td>
                        </tr>
                        <tr class="nobrd">
                            <td>
                                <div class="preview-item-name">Email:</div>
                            </td>
                            <td colspan="3">
                                <div class="preview-item-value">{{estimateTo.customer.email}}</div>
                            </td>
                        </tr>
                        <tr class="nobrd" v-if="estimateTo.customer.customer_type == 'B'">
                            <td>
                                <div class="preview-item-name">ABN:</div>
                            </td>
                            <td colspan="3">
                                <div class="preview-item-value">{{estimateTo.customer.abn}}</div>
                            </td>
                        </tr>
                        <tr class="nobrd" v-if="!isVendorBrandingType1&& !isVendorBrandingType2">
                            <td>
                                <div class="preview-item-name">Insurer Name:</div>
                            </td>
                            <td colspan="3">
                                <div class="preview-item-value">{{estimateTo.insurance.insurer_name}}</div>
                            </td>
                        </tr>
                        <tr class="nobrd" v-if="!isVendorBrandingType1 && !isVendorBrandingType2">
                          <td>
                            <div class="preview-item-name">Insurer ABN:</div>
                          </td>
                          <td colspan="3">
                            <div class="preview-item-value">{{estimateTo.insurance.abn}}</div>
                          </td>
                        </tr>
                        <tr v-if="!isVendorBrandingType2" class="nobrd">
                            <td>
                                <div class="preview-item-name">Claim Number:</div>
                            </td>
                            <td colspan="3">
                                <div class="preview-item-value">{{estimateTo.insurance.claim_number}}</div>
                            </td>
                        </tr>
                    </table>
                </td>
                <td colspan="5">
                    <table class="nobrd">
                        <tr>
                            <td class="w-50">
                                <table class="nobrd">
                                    <tr>
                                        <td class="w-33"></td>
                                        <td class="w-33"></td>
                                        <td class="w-33"></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="preview-item-name">Make:</div>
                                        </td>
                                        <td colspan="2">
                                            <div class="preview-item-value">{{estimateTo.customer_vehicle.make}}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="preview-item-name">Model:</div>
                                        </td>
                                        <td colspan="2">
                                            <div class="preview-item-value">{{estimateTo.customer_vehicle.model}}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="preview-item-name">Series:</div>
                                        </td>
                                        <td colspan="2">
                                            <div v-if="estimateTo && estimateTo.properties && estimateTo.properties.isHideSeries && estimateTo.properties.isHideSeries === true"
                                                 class="preview-item-value"> </div>
                                            <div v-else class="preview-item-value">{{estimateTo.customer_vehicle.series}}</div>
                                        </td>
                                    </tr>
                                    <tr v-if="!isVendorBrandingType1 && !isEstimateMethodologyCustom && estimateTo.customer_vehicle.series_shedule_number != ''">
                                        <td>
                                            <div class="preview-item-name">Schedule Number:</div>
                                        </td>
                                        <td colspan="2">
                                            <div class="preview-item-value">{{estimateTo.customer_vehicle.series_shedule_number}}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="preview-item-name">Transmission:</div>
                                        </td>
                                        <td colspan="2">
                                            <div class="preview-item-value">{{estimateTo.customer_vehicle.transmission}}</div>
                                        </td>
                                    </tr>
                                    <tr v-if="!isVendorBrandingType1 && !isVendorBrandingType2">
                                        <td>
                                            <div class="preview-item-name">Paint Code:</div>
                                        </td>
                                        <td colspan="2">
                                            <div class="preview-item-value">{{estimateTo.customer_vehicle.colour}}</div>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                            <td class="w-50">
                                <table class="nobrd">
                                    <tr>
                                        <td class="w-33"></td>
                                        <td class="w-33"></td>
                                        <td class="w-33"></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="preview-item-name">Rego:</div>
                                        </td>
                                        <td colspan="2">
                                            <div class="preview-item-value">{{estimateTo.customer_vehicle.rego_number}}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="preview-item-name">VIN Number:</div>
                                        </td>
                                        <td colspan="2">
                                            <div class="preview-item-value">{{estimateTo.customer_vehicle.vin}}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="preview-item-name">Cylinders:</div>
                                        </td>
                                        <td colspan="2">
                                            <div class="preview-item-value">{{estimateTo.customer_vehicle.cylinders}}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="preview-item-name">Build Date:</div>
                                        </td>
                                        <td colspan="2">
                                            <div class="preview-item-value">{{estimateTo.customer_vehicle.dom}}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="preview-item-name">Odometer:</div>
                                        </td>
                                        <td colspan="2">
                                            <div class="preview-item-value">{{estimateTo.customer_vehicle.odometer}}</div>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr v-if="!isVendorBrandingType2" class="nobrd">
                <td colspan="9">
                    <div class="preview-delimiter"></div>
                </td>
            </tr>
            <tr class="nobrd">
                <td colspan="9">
                    <div class="preview-head-name">Repairs</div>
                </td>
            </tr>
            <!--
             RR with hours
            -->
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] !=''">
                <td colspan="6">
                    <div class="preview-subhead-name">R&R</div>
                </td>
                <td>
                    <div class="preview-subhead-name">
                      <span v-if="isEstimateMethodologyDollar"></span>
                      <span v-else>Hrs</span>
                    </div>
                </td>
                <td>
                    <div class="preview-subhead-name">
                      <span v-if="isEstimateMethodologyDollar"></span>
                      <span v-else>Rate</span>
                    </div>
                </td>
                <td>
                    <div class="preview-subhead-name preview-amount-header">Amount</div>
                </td>
            </tr>
            <tr v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] !=''"
                v-for="line in estimateTo.line_items.lines.RR">
                <td colspan="6">
                    <div class="preview-item-name">{{line.name}}
                        <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                            Comment: <span>{{line.manual_pdf_comment}}</span>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value">
                      <span v-if="line.isOnReport">On Report</span>
                      <span v-else-if="isEstimateMethodologyDollar || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else>{{line.hrs_str}}</span>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value">
                      <span v-if="line.isOnReport">On Report</span>
                      <span v-else-if="isEstimateMethodologyDollar || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else>{{line.rate_str}}</span>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value preview-amount">{{line.isOnReport ? 'On Report' : line.total_str}}</div>
                </td>
            </tr>
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] !=''">
                <td colspan="5">
                    <div class="preview-item-name preview-align-right">Subtotal Hrs</div>
                </td>
                <td>
                    <div class="preview-item-name">{{estimateTo.line_items.summary["RR-Hrs-SubTotal-Str"]}}</div>
                </td>
                <td>
                    <div class="preview-item-value"></div>
                </td>
                <td>
                    <div class="preview-item-name preview-align-right">Subtotal</div>
                </td>
                <td>
                    <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["RR-Total-SubTotal-Str"]}}</div>
                </td>
            </tr>
            <!--
            RR without hours
           -->
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] ==''">
                <td colspan="8">
                    <div class="preview-subhead-name">R&R</div>
                </td>
                <td>
                    <div class="preview-subhead-name preview-amount-header">Amount</div>
                </td>
            </tr>
            <tr v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] ==''"
                v-for="line in estimateTo.line_items.lines.RR">
                <td colspan="8">
                    <div class="preview-item-name">{{line.name}}
                        <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                            Comment: <span>{{line.manual_pdf_comment}}</span>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value">{{line.isOnReport ? 'On Report' : line.total_str}}</div>
                </td>
            </tr>
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] ==''">
                <td colspan="8">
                    <div class="preview-item-name preview-align-right">Subtotal</div>
                </td>
                <td>
                    <div class="preview-item-name  preview-amount">{{estimateTo.line_items.summary["RR-Total-SubTotal-Str"]}}</div>
                </td>
            </tr>
            <!--
           Delimiter
          -->
            <tr class="nobrd">
                <td colspan="9">
                    <div class="preview-delimiter"></div>
                </td>
            </tr>
            <!--
             Repair with hours
            -->
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] !=''">
                <td colspan="6">
                    <div class="preview-subhead-name">Repair</div>
                </td>
                <td>
                    <div class="preview-subhead-name">
                      <span v-if="isEstimateMethodologyDollar"></span>
                      <span v-else>Hrs</span>
                    </div>
                </td>
                <td>
                    <div class="preview-subhead-name">
                      <span v-if="isEstimateMethodologyDollar"></span>
                      <span v-else>Rate</span>
                    </div>
                </td>
                <td>
                    <div class="preview-subhead-name preview-amount-header">Amount</div>
                </td>
            </tr>
            <tr v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] !=''"
                v-for="line in estimateTo.line_items.lines.Repair">
                <td colspan="6">
                    <div class="preview-item-name">{{line.name}}
                        <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                            Comment: <span>{{line.manual_pdf_comment}}</span>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value">
                      <span v-if="line.isOnReport">On Report</span>
                      <span v-else-if="isEstimateMethodologyDollar || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else>{{line.hrs_str}}</span>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value">
                      <span v-if="line.isOnReport">On Report</span>
                      <span v-else-if="isEstimateMethodologyDollar || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else>{{line.rate_str}}</span>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value preview-amount">{{line.isOnReport ? 'On Report' : line.total_str}}</div>
                </td>
            </tr>
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] !=''">
                <td colspan="5">
                    <div class="preview-item-name preview-align-right">Subtotal Hrs</div>
                </td>
                <td>
                    <div class="preview-item-name">{{estimateTo.line_items.summary["Repair-Hrs-SubTotal-Str"]}}</div>
                </td>
                <td>
                    <div class="preview-item-value"></div>
                </td>
                <td>
                    <div class="preview-item-name preview-align-right">Subtotal</div>
                </td>
                <td>
                    <div class="preview-item-name  preview-amount">{{estimateTo.line_items.summary["Repair-Total-SubTotal-Str"]}}</div>
                </td>
            </tr>
            <!--
            Repair without hours
             -->
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] ==''">
                <td colspan="8">
                    <div class="preview-subhead-name">Repair</div>
                </td>
                <td>
                    <div class="preview-subhead-name preview-amount-header">Amount</div>
                </td>
            </tr>
            <tr v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] ==''"
                v-for="line in estimateTo.line_items.lines.Repair">
                <td colspan="8">
                    <div class="preview-item-name">{{line.name}}
                        <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                            Comment: <span>{{line.manual_pdf_comment}}</span>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value preview-amount">{{line.isOnReport ? 'On Report' : line.total_str}}</div>
                </td>
            </tr>
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] ==''">
                <td colspan="8">
                    <div class="preview-item-name preview-align-right">Subtotal</div>
                </td>
                <td>
                    <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Repair-Total-SubTotal-Str"]}}</div>
                </td>
            </tr>
            <!--
           Delimiter
          -->
            <tr v-if="!!estimateTo.line_items.lines.Repair.length" class="nobrd">
                <td colspan="9">
                    <div class="preview-delimiter"></div>
                </td>
            </tr>
            <!--
                                           Paint with hours
                                           -->
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] !=''">
                <td colspan="6">
                    <div class="preview-subhead-name">Paint</div>
                </td>
                <td>
                    <div class="preview-subhead-name">
                      <span v-if="isEstimateMethodologyDollar"></span>
                      <span v-else>Hrs</span>
                    </div>
                </td>
                <td>
                    <div class="preview-subhead-name">
                      <span v-if="isEstimateMethodologyDollar"></span>
                      <span v-else>Rate</span>
                    </div>
                </td>
                <td>
                    <div class="preview-subhead-name preview-amount-header">Amount</div>
                </td>
            </tr>
            <tr v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] !=''"
                v-for="line in estimateTo.line_items.lines.Paint">
                <td colspan="6">
                    <div class="preview-item-name">{{line.name}}
                        <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                            Comment: <span>{{line.manual_pdf_comment}}</span>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value">
                      <span v-if="line.isOnReport">On Report</span>
                      <span v-else-if="isEstimateMethodologyDollar || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else>{{line.hrs_str}}</span>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value">
                      <span v-if="line.isOnReport">On Report</span>
                      <span v-else-if="isEstimateMethodologyDollar || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                      <span v-else>{{line.rate_str}}</span>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value preview-amount">{{line.isOnReport ? 'On Report' : line.total_str}}</div>
                </td>
            </tr>
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] !=''">
                <td colspan="5">
                    <div class="preview-item-name preview-align-right">Subtotal Hrs</div>
                </td>
                <td>
                    <div class="preview-item-name">{{estimateTo.line_items.summary["Paint-Hrs-SubTotal-Str"]}}</div>
                </td>
                <td>
                    <div class="preview-item-value"></div>
                </td>
                <td>
                    <div class="preview-item-name preview-align-right">Subtotal</div>
                </td>
                <td>
                    <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Paint-Total-SubTotal-Str"]}}</div>
                </td>
            </tr>
            <!--
                                            Paint without hours
                                             -->
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] ==''">
                <td colspan="8">
                    <div class="preview-subhead-name">Paint</div>
                </td>
                <td>
                    <div class="preview-subhead-name preview-amount-header">Amount</div>
                </td>
            </tr>
            <tr v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] ==''"
                v-for="line in estimateTo.line_items.lines.Paint">
                <td colspan="8">
                    <div class="preview-item-name">{{line.name}}
                        <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                            Comment: <span>{{line.manual_pdf_comment}}</span>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value preview-amount">{{line.isOnReport ? 'On Report' : line.total_str}}</div>
                </td>
            </tr>
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] ==''">
                <td colspan="8">
                    <div class="preview-item-name preview-align-right">Subtotal</div>
                </td>
                <td>
                    <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Paint-Total-SubTotal-Str"]}}</div>
                </td>
            </tr>
            <!--
            Labour
            -->
          <tr class="nobrd"
              v-if="(!!estimateTo.line_items.lines.Paint.length || !!estimateTo.line_items.lines.Repair.length || !!estimateTo.line_items.lines.RR.length) && estimateTo.line_items.summary['Labour-Hrs-Str'] != ''">
            <td colspan="8">
              <div class="preview-item-name preview-align-right">Total Labour Hours</div>
            </td>
            <td>
              <div class="preview-item-name">{{estimateTo.line_items.summary["Labour-Hrs-Str"]}}</div>
            </td>
          </tr>
          <tr class="nobrd"
              v-if="(!!estimateTo.line_items.lines.Paint.length || !!estimateTo.line_items.lines.Repair.length || !!estimateTo.line_items.lines.RR.length) && estimateTo.line_items.summary['Labour-Hrs-Str'] != ''">
            <td colspan="8">
              <div class="preview-item-name preview-align-right">Subtotal Amount</div>
            </td>
            <td>
              <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Labour-Cost-Str"]}}</div>
            </td>
          </tr>
          <tr class="nobrd"
              v-if="(!!estimateTo.line_items.lines.Paint.length || !!estimateTo.line_items.lines.Repair.length || !!estimateTo.line_items.lines.RR.length) && estimateTo.line_items.summary['Labour-Hrs-Str'] == ''">
            <td colspan="8">
              <div class="preview-item-name preview-align-right">Subtotal Amount</div>
            </td>
            <td>
              <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Labour-Cost-Str"]}}</div>
            </td>
          </tr>
            <!--
           Delimiter
          -->
            <tr v-if="!!estimateTo.line_items.lines.Paint.length" class="nobrd">
                <td colspan="9">
                    <div class="preview-delimiter"></div>
                </td>
            </tr>
            <!--
             Parts
            -->
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Part.length">
                <td colspan="5">
                    <div class="preview-subhead-name">Parts</div>
                </td>
                <td>
                    <div class="preview-subhead-name">Part No</div>
                </td>
                <td>
                    <div class="preview-subhead-name">Qty</div>
                </td>
                <td>
                    <div class="preview-subhead-name preview-subhead-unit-price">Unit Price</div>
                </td>
                <td>
                    <div class="preview-subhead-name preview-amount-header">Amount</div>
                </td>
            </tr>
            <tr v-if="!!estimateTo.line_items.lines.Part.length" v-for="line in estimateTo.line_items.lines.Part">
                <td colspan="5">
                    <div class="preview-item-name">{{line.name}}
                        <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                            Comment: <span>{{line.manual_pdf_comment}}</span>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value">{{line.part_num}}</div>
                </td>
                <td>
                    <div class="preview-item-value">{{line.isOnReport ? 'On Report' : line.qty}}</div>
                </td>
                <td>
                    <div class="preview-item-value">{{line.isOnReport ? 'On Report' : line.rate_str}}</div>
                </td>
                <td>
                    <div class="preview-item-value preview-amount">{{line.isOnReport ? 'On Report' : line.total_str}}</div>
                </td>
            </tr>
            <tr v-if="!!estimateTo.line_items.lines.Part.length" class="nobrd">
                <td colspan="8">
                    <div class="preview-item-name preview-align-right">Subtotal</div>
                </td>
                <td>
                    <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Part-Total-SubTotal-Str"]}}</div>
                </td>
            </tr>
            <!--
            Delimiter
            -->
            <tr v-if="!!estimateTo.line_items.lines.Part.length" class="nobrd">
                <td colspan="9">
                    <div class="preview-delimiter"></div>
                </td>
            </tr>
            <!--
            PDR
            -->
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.PDR.length">
                <td colspan="4">
                    <div class="preview-subhead-name">PDR</div>
                </td>
                <td>
                    <div class="preview-subhead-name">Material</div>
                </td>
                <td>
                    <div class="preview-subhead-name">Action</div>
                </td>
                <td>
                    <div class="preview-subhead-name">Qty</div>
                </td>
                <td>
                    <div class="preview-subhead-name">Price</div>
                </td>
                <td>
                    <div class="preview-subhead-name preview-amount-header">Amount</div>
                </td>
            </tr>
            <tr v-if="!!estimateTo.line_items.lines.PDR.length" v-for="line in estimateTo.line_items.lines.PDR">
                <td colspan="4">
                    <div class="preview-item-name">{{line.name}}
                        <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                            Comment: <span>{{line.manual_pdf_comment}}</span>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value">{{line.type === 'panel' ? line.material : ''}}</div>
                </td>
                <td>
                    <div class="preview-item-value">{{line.type === 'panel' ? line.action : ''}}</div>
                </td>
                <td>
                    <div class="preview-item-value">{{line.qty}}</div>
                </td>
                <td>
                    <div class="preview-item-value">{{line.price}}</div>
                </td>
                <td>
                    <div class="preview-item-value preview-amount">{{line.total_str}}</div>
                </td>
            </tr>
            <tr v-if="!!estimateTo.line_items.lines.PDR.length" class="nobrd">
                <td colspan="8">
                    <div class="preview-item-name preview-align-right">Subtotal</div>
                </td>
                <td>
                    <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["PDR-Total-SubTotal-Str"]}}</div>
                </td>
            </tr>
            <!--
            Delimiter
            -->
            <tr v-if="!!estimateTo.line_items.lines.PDR.length" class="nobrd">
                <td colspan="9">
                    <div class="preview-delimiter"></div>
                </td>
            </tr>
            <!--
            Materials
                    -->
            <tr v-if="!!estimateTo.line_items.lines.Materials.length" class="nobrd">
                <td colspan="7">
                    <div class="preview-subhead-name">Materials</div>
                </td>
                <td>
                    <div class="preview-subhead-name">Hrs</div>
                </td>
                <td>
                    <div class="preview-subhead-name preview-amount-header">Amount</div>
                </td>
            </tr>
            <tr v-if="!!estimateTo.line_items.lines.Materials.length" v-for="line in estimateTo.line_items.lines.Materials">
                <td colspan="7">
                    <div class="preview-item-name">{{line.name}}
                        <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                            Comment: <span>{{line.manual_pdf_comment}}</span>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value">{{line.hrs_str}}</div>
                </td>
                <td>
                    <div class="preview-item-value preview-amount">{{line.total_str}}</div>
                </td>
            </tr>
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Materials.length">
                <td colspan="8">
                    <div class="preview-item-name preview-align-right">Subtotal</div>
                </td>
                <td>
                    <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Materials-Total-Str"]}}</div>
                </td>
            </tr>
            <!--
            Delimiter
            -->
            <tr v-if="!!estimateTo.line_items.lines.Materials.length" class="nobrd">
                <td colspan="9">
                    <div class="preview-delimiter"></div>
                </td>
            </tr>
            <!--
            Sublet with Hrs
           -->
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Sublet.length && estimateTo.line_items.summary['Sublet-Hrs-SubTotal-Str'] !=''">
                <td colspan="4">
                    <div class="preview-subhead-name">Sublet</div>
                </td>
                <td>
                    <div class="preview-subhead-name">Repairer</div>
                </td>
                <td>
                    <div class="preview-subhead-name">Hrs</div>
                </td>
                <td>
                    <div class="preview-subhead-name">Rate</div>
                </td>
                <td>
                    <div class="preview-subhead-name"></div>
                </td>
                <td>
                    <div class="preview-subhead-name preview-amount-header">Amount</div>
                </td>
            </tr>
            <tr v-if="!!estimateTo.line_items.lines.Sublet.length && estimateTo.line_items.summary['Sublet-Hrs-SubTotal-Str'] !=''"
                v-for="line in estimateTo.line_items.lines.Sublet">
                <td colspan="4">
                    <div class="preview-item-name">{{line.name}}
                        <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                            Comment: <span>{{line.manual_pdf_comment}}</span>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value">{{line.isOnReport ? 'On Report' : line.repairer}}</div>
                </td>
                <td>
                    <div class="preview-item-value">{{line.isOnReport ? 'On Report' : line.hrs_str}}</div>
                </td>
                <td>
                    <div class="preview-item-value">{{line.isOnReport ? 'On Report' : line.rate_str}}</div>
                </td>
                <td>
                    <div class="preview-item-value"></div>
                </td>
                <td>
                    <div class="preview-item-value preview-amount">{{line.isOnReport ? 'On Report' : line.total_str}}</div>
                </td>
            </tr>
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Sublet.length && estimateTo.line_items.summary['Sublet-Hrs-SubTotal-Str'] != ''">
                <td colspan="6">
                    <div class="preview-item-name preview-align-right">Subtotal Hrs</div>
                </td>
                <td>
                    <div class="preview-item-name preview-align-right">{{estimateTo.line_items.summary["Sublet-Hrs-SubTotal-Str"]}}</div>
                </td>
                <td>
                    <div class="preview-item-name preview-align-right">Subtotal</div>
                </td>
                <td>
                    <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Sublet-Total-SubTotal-Str"]}}</div>
                </td>
            </tr>
            <!--
           Sublet without Hrs
          -->
            <tr v-if="!!estimateTo.line_items.lines.Sublet.length && estimateTo.line_items.summary['Sublet-Hrs-SubTotal-Str'] ==''" class="nobrd">
                <td colspan="5">
                    <div class="preview-subhead-name">Sublet</div>
                </td>
                <td>
                    <div class="preview-subhead-name">Repairer</div>
                </td>
                <td>
                    <div class="preview-subhead-name"></div>
                </td>
                <td>
                    <div class="preview-subhead-name"></div>
                </td>
                <td>
                    <div class="preview-subhead-name preview-amount-header">Amount</div>
                </td>
            </tr>
            <tr v-if="!!estimateTo.line_items.lines.Sublet.length && estimateTo.line_items.summary['Sublet-Hrs-SubTotal-Str'] ==''"
                v-for="line in estimateTo.line_items.lines.Sublet">
                <td colspan="5">
                    <div class="preview-item-name">{{line.name}}
                        <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                            Comment: <span>{{line.manual_pdf_comment}}</span>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value">{{line.isOnReport ? 'On Report' : line.repairer}}</div>
                </td>
                <td>
                    <div class="preview-item-value"></div>
                </td>
                <td>
                    <div class="preview-item-value"></div>
                </td>
                <td>
                    <div class="preview-item-value preview-amount">{{line.isOnReport ? 'On Report' : line.total_str}}</div>
                </td>
            </tr>
            <tr v-if="!!estimateTo.line_items.lines.Sublet.length && estimateTo.line_items.summary['Sublet-Hrs-SubTotal-Str'] == ''" class="nobrd">
                <td colspan="8">
                    <div class="preview-item-name preview-align-right">Subtotal</div>
                </td>
                <td>
                    <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Sublet-Total-SubTotal-Str"]}}</div>
                </td>
            </tr>
            <!--
           Delimiter
          -->
            <tr v-if="!!estimateTo.line_items.lines.Sublet.length" class="nobrd">
                <td colspan="9">
                    <div class="preview-delimiter"></div>
                </td>
            </tr>
            <!--
             Other
            -->
            <tr v-if="!!estimateTo.line_items.lines.Other.length" class="nobrd">
                <td colspan="8">
                    <div class="preview-subhead-name">
                      <template v-if="isVendorBrandingType2">Item</template>
                      <template v-else-if="isVendorBrandingType3">Description</template>
                      <template v-else>Other</template>
                    </div>
                </td>
                <td>
                    <div class="preview-subhead-name preview-amount-header">Amount</div>
                </td>
            </tr>
            <tr v-if="!!estimateTo.line_items.lines.Other.length" v-for="line in estimateTo.line_items.lines.Other">
                <td colspan="8">
                    <div class="preview-item-name">{{line.name}}
                        <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                            Comment: <span>{{line.manual_pdf_comment}}</span>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="preview-item-value preview-amount">{{line.isOnReport ? 'On Report' : line.total_str}}</div>
                </td>
            </tr>
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Other.length">
                <td colspan="8">
                    <div class="preview-item-name preview-align-right">Subtotal</div>
                </td>
                <td>
                    <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Other-Total-SubTotal-Str"]}}</div>
                </td>
            </tr>
            <!--
            Total
            -->
            <tr v-if="countSubtotal > 1 && !isHideGST" class="nobrd">
                <td colspan="8">
                    <div class="preview-item-name preview-align-right">Total</div>
                </td>
                <td>
                    <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Total_str"]}}</div>
                </td>
            </tr>
            <tr v-if="!isHideGST" class="nobrd">
                <td colspan="8">
                    <div class="preview-item-name preview-align-right">GST</div>
                </td>
                <td>
                    <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary.GST_str}}</div>
                </td>
            </tr>
            <tr v-if="!isHideGST" class="nobrd">
                <td colspan="7">
                    <div class="preview-item-name preview-align-right"></div>
                </td>
                <td colspan="">
                    <div class="preview-item-name preview-align-right"
                         style="border-top: 1px solid rgba(27, 30, 56, 0.25) !important;margin-left: 45px; padding-left: 0px;
">Total Inc GST
                    </div>
                </td>
                <td>
                    <div class="preview-item-name preview-amount"
                         style="border-top:1px solid rgba(27,30,56,0.25) !important; position: relative;"
                    >{{estimateTo.line_items.summary.GrandTotal_str}}
                        <div class="preview-total-plus"></div>
                    </div>

                </td>
            </tr>
            <tr v-if="isHideGST" class="nobrd">
              <td colspan="7">
                <div class="preview-item-name preview-align-right"></div>
              </td>
              <td colspan="">
                <div class="preview-item-name preview-align-right"
                     style="border-top: 1px solid rgba(27, 30, 56, 0.25) !important;margin-left: 45px; padding-left: 0px;
  ">Total
                </div>
              </td>
              <td>
                <div class="preview-item-name preview-amount"
                     style="border-top:1px solid rgba(27,30,56,0.25) !important; position: relative;"
                >{{estimateTo.line_items.summary["GrandTotal_str"]}}
                  <div class="preview-total-plus"></div>
                </div>

              </td>
            </tr>
            <tr class="nobrd">
                <td colspan="9">
                    <div class="preview-terms-delimeter"></div>
                </td>
            </tr>
          <template v-if="estimateTo?.note_terms != '' && estimateTo?.terms != ''">
            <tr class="nobrd">
                <td colspan="9">
                  <table style="width: 100%">
                    <tr>
                      <td style="width: 50%; padding-right: 5px; border: none">
                        <div class="border-td">
                          <div class="preview-terms-header">Terms</div>
                          <div class="preview-terms" v-html="estimateTo.terms"></div>
                        </div>
                      </td>
                      <td style="width: 50%; padding-left: 5px; border: none">
                        <div class="border-td">
                          <div class="preview-terms-header">Estimate Note</div>
                          <div class="preview-terms" v-html="estimateTo?.note_terms"></div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
            </tr>
          </template>
          <template v-else-if="estimateTo?.terms != ''">
            <tr class="nobrd">
              <td colspan="9">
                <table style="width: 100%">
                  <tr>
                    <td style=" border: none">
                      <div class="border-td">
                        <div class="preview-terms-header">Terms</div>
                        <div class="preview-terms" v-html="estimateTo?.terms"></div>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </template>
          <template v-else-if="estimateTo?.note_terms">
            <tr class="nobrd">
              <td colspan="9">
                <table style="width: 100%">
                  <tr>
                    <td style=" border: none">
                      <div class="border-td">
                        <div class="preview-terms-header">Estimate Note</div>
                        <div class="preview-terms" v-html="estimateTo?.note_terms"></div>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr class="nobrd">
              <td colspan="9">
              </td>
            </tr>
          </template>
        </table>
        <div v-else class="table b-table table-preview rs-scroll rs-scroll--y table-preview-mobile">
        <div class="nobrd">
          <div>
            <div class="preview-logo"><img :src="vendorInfo.logo" alt=""></div>
          </div>
          <div>
            <div class="preview-header" style="padding-left: 10px">
              <div class="preview-header-title">ESTIMATE</div>
              <div class="preview-header-business-name">{{estimateTo.vendor.business_name}}</div>
              <div class="preview-header-item"><span class="preview-header-item-name">ABN:</span> <span class="preview-header-item-value">{{estimateTo.vendor.abn}}</span>
              </div>
              <div class="preview-header-item"><span class="preview-header-item-name">License:</span> <span
                  class="preview-header-item-value">{{estimateTo.vendor.license_number}}</span>
              </div>
              <div class="preview-header-item" v-if="estimateTo.vendor.postal_address"><span class="preview-header-item-value">{{estimateTo.vendor.postal_address}}</span>
              </div>
              <div class="preview-header-item" v-if="!estimateTo.vendor.postal_address"><span class="preview-header-item-value">{{estimateTo.vendor.postal_street}} {{estimateTo.vendor.postal_suburb}}</span>
              </div>
              <div class="preview-header-item" v-if="!estimateTo.vendor.postal_address"><span class="preview-header-item-value">{{estimateTo.vendor.postal_state}} {{estimateTo.vendor.postal_country}}</span>
              </div>
              <div class="preview-header-item"><span class="preview-header-item-name">Email:</span> <span class="preview-header-item-value">{{estimateTo.vendor.email}}</span>
              </div>
              <div class="preview-header-item"><span class="preview-header-item-name">Phone:</span> <span class="preview-header-item-value">{{estimateTo.vendor.phone_area_code}} {{estimateTo.vendor.phone}}</span>
              </div>
              <div class="preview-header-delimiter"></div>
              <div class="preview-header-item"><span class="preview-header-item-name">Estimate Number: </span>
                <span v-if="estimateTo.estimate.supplement_number > 0" class="preview-header-item-value"> {{estimateTo.estimate.estimate_number}} - {{estimateTo.estimate.supplement_number}}</span>
                <span v-else class="preview-header-item-value">{{estimateTo.estimate.estimate_number}}</span>
              </div>
              <div class="preview-header-item"><span class="preview-header-item-name">Estimator:</span> <span class="preview-header-item-value">{{estimateTo.estimate.estimator}}</span>
              </div>
              <div class="preview-header-item"><span class="preview-header-item-name">Date:</span> <span class="preview-header-item-value">{{estimateTo.estimate.created_on}}</span>
              </div>
              <div class="preview-header-item"><span class="preview-header-item-name">Expiry:</span> <span class="preview-header-item-value">{{estimateTo.estimate.expires_on}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="nobrd">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div class="nobrd">
          <div>
            <div class="preview-head-name">Vehicle & Owner</div>
          </div>
        </div>
        <div class="nobrd">
          <div>
            <div>
              <div class="nobrd">
                <div class="w-25"></div>
                <div class="w-25"></div>
                <div class="w-25"></div>
                <div class="w-25"></div>
              </div>
              <div class="nobrd d-flex">
                <div>
                  <div class="preview-item-name" style="min-width: 114px;">Owner Name:</div>
                </div>
                <div>
                  <div class="preview-item-value">{{estimateTo.customer.customer_name}}</div>
                </div>
              </div>
              <div class="nobrd d-flex">
                <div>
                  <div class="preview-item-name">Home Phone:</div>
                </div>
                <div>
                  <div class="preview-item-value">{{estimateTo.customer.phone}}</div>
                </div>
              </div>
              <div class="nobrd d-flex">
                <div>
                  <div class="preview-item-name">Mobile Phone:</div>
                </div>
                <div>
                  <div class="preview-item-value">{{estimateTo.customer.mobile}}</div>
                </div>
              </div>
              <div class="nobrd d-flex">
                <div>
                  <div class="preview-item-name">Email:</div>
                </div>
                <div>
                  <div class="preview-item-value">{{estimateTo.customer.email}}</div>
                </div>
              </div>
              <div class="nobrd d-flex" v-if="estimateTo.customer.customer_type == 'B'">
                <div>
                  <div class="preview-item-name">ABN:</div>
                </div>
                <div>
                  <div class="preview-item-value">{{estimateTo.customer.abn}}</div>
                </div>
              </div>
              <div class="nobrd d-flex">
                <div>
                  <div class="preview-item-name">Insurer Name:</div>
                </div>
                <div>
                  <div class="preview-item-value">{{estimateTo.insurance.insurer_name}}</div>
                </div>
              </div>
              <div class="nobrd d-flex">
                <div>
                  <div class="preview-item-name">Insurer ABN:</div>
                </div>
                <div>
                  <div class="preview-item-value">{{estimateTo.insurance.abn}}</div>
                </div>
              </div>
              <div class="nobrd d-flex">
                <div>
                  <div class="preview-item-name">Claim Number:</div>
                </div>
                <div>
                  <div class="preview-item-value">{{estimateTo.insurance.claim_number}}</div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="nobrd">
              <div>
                <div class="w-50" style="margin-top: 10px">
                  <div class="nobrd">
                    <div class="d-flex">
                      <div>
                        <div class="preview-item-name">Make:</div>
                      </div>
                      <div>
                        <div class="preview-item-value">{{estimateTo.customer_vehicle.make}}</div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div>
                        <div class="preview-item-name">Model:</div>
                      </div>
                      <div>
                        <div class="preview-item-value">{{estimateTo.customer_vehicle.model}}</div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div>
                        <div class="preview-item-name">Series:</div>
                      </div>
                      <div>
                        <div v-if="estimateTo && estimateTo.properties && estimateTo.properties.isHideSeries && estimateTo.properties.isHideSeries === true"
                             class="preview-item-value"> </div>
                        <div v-else class="preview-item-value">{{estimateTo.customer_vehicle.series}}</div>
                      </div>
                    </div>
                    <div v-if="!isEstimateMethodologyCustom && estimateTo.customer_vehicle.series_shedule_number != ''"
                         class="d-flex">
                      <div>
                        <div class="preview-item-name">Schedule Number:</div>
                      </div>
                      <div>
                        <div class="preview-item-value">{{estimateTo.customer_vehicle.series_shedule_number}}</div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div>
                        <div class="preview-item-name">Transmission:</div>
                      </div>
                      <div>
                        <div class="preview-item-value">{{estimateTo.customer_vehicle.transmission}}</div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div>
                        <div class="preview-item-name">Paint Code:</div>
                      </div>
                      <div>
                        <div class="preview-item-value">{{estimateTo.customer_vehicle.colour}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-50">
                  <div class="nobrd">
                    <div class="d-flex">
                      <div>
                        <div class="preview-item-name">Rego:</div>
                      </div>
                      <div>
                        <div class="preview-item-value">{{estimateTo.customer_vehicle.rego_number}}</div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div>
                        <div class="preview-item-name">VIN Number:</div>
                      </div>
                      <div>
                        <div class="preview-item-value">{{estimateTo.customer_vehicle.vin}}</div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div>
                        <div class="preview-item-name">Cylinders:</div>
                      </div>
                      <div>
                        <div class="preview-item-value">{{estimateTo.customer_vehicle.cylinders}}</div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div>
                        <div class="preview-item-name">Build Date:</div>
                      </div>
                      <div>
                        <div class="preview-item-value">{{estimateTo.customer_vehicle.dom}}</div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div>
                        <div class="preview-item-name">Odometer:</div>
                      </div>
                      <div>
                        <div class="preview-item-value">{{estimateTo.customer_vehicle.odometer}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="nobrd"
             v-if="estimateTo.line_items.lines.RR.length>0 || estimateTo.line_items.lines.Paint.length>0 || estimateTo.line_items.lines.Repair.length>0">
          <div>
            <div class="preview-head-name">Repairs</div>
          </div>
        </div>
        <!--
         RR with hours
        -->
        <table class="main-table estimate-parts border-t" v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] !=''">
          <thead>
            <tr>
              <th style="padding-left: 15px;">R&R</th>
              <th style="padding-left: 15px;">
                <span v-if="isEstimateMethodologyDollar"></span>
                <span v-else>Hrs</span>
              </th>
              <th style="padding-left: 15px;">
                <span v-if="isEstimateMethodologyDollar"></span>
                <span v-else>Rate</span>
              </th>
              <th style="padding-left: 15px;">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] !=''"
                v-for="line in estimateTo.line_items.lines.RR">
              <td>
                <div class="preview-item-name">{{line.name}}
                  <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                    Comment: <span>{{line.manual_pdf_comment}}</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="preview-item-value">
                  <span v-if="isEstimateMethodologyDollar || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                  <span v-else>{{line.hrs_str}}</span>
                </div>
              </td>
              <td>
                <div class="preview-item-value">
                  <span v-if="isEstimateMethodologyDollar || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                  <span v-else>{{line.rate_str}}</span>
                </div>
              </td>
              <td>
                <div class="preview-item-value preview-amount">{{line.total_str}}</div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] !=''">
              <td>
                <div class="preview-item-name preview-align-right">Subtotal Hrs</div>
              </td>
              <td>
                <div class="preview-item-name">{{estimateTo.line_items.summary["RR-Hrs-SubTotal-Str"]}}</div>
              </td>
              <td>
                <div class="preview-item-name preview-align-right">Subtotal</div>
              </td>
              <td>
                <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["RR-Total-SubTotal-Str"]}}</div>
              </td>
            </tr>
          </tfoot>
        </table>
        <!--
        RR without hours
       -->
        <table class="main-table estimate-parts border-t" v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] ==''">
          <thead>
            <tr>
              <th colspan="8" style="padding-left: 15px;">R&R</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] ==''"
                v-for="line in estimateTo.line_items.lines.RR">
              <td colspan="8">
                <div class="preview-item-name">{{line.name}}
                  <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                    Comment: <span>{{line.manual_pdf_comment}}</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="preview-item-value">{{line.total_str}}</div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.RR.length && estimateTo.line_items.summary['RR-Hrs-SubTotal-Str'] ==''">
              <td colspan="8">
                <div class="preview-item-name preview-align-right">Subtotal</div>
              </td>
              <td>
                <div class="preview-item-name preview-amount" style="text-align: center">{{estimateTo.line_items.summary["RR-Total-SubTotal-Str"]}}</div>
              </td>
            </tr>
          </tfoot>
        </table>
        <!--
       Delimiter
      -->
        <tr class="nobrd">
          <td colspan="9">
            <div class="preview-delimiter"></div>
          </td>
        </tr>
        <!--
         Repair with hours
        -->
        <table class="main-table estimate-parts border-t" v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] !=''">
          <thead>
            <tr>
              <th style="padding-left: 15px;">Repair</th>
              <th style="padding-left: 15px;">
                <span v-if="isEstimateMethodologyDollar"></span>
                <span v-else>Hrs</span>
              </th>
              <th style="padding-left: 15px;">
                <span v-if="isEstimateMethodologyDollar"></span>
                <span v-else>Rate</span>
              </th>
              <th style="padding-left: 15px;">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] !=''"
                v-for="line in estimateTo.line_items.lines.Repair">
              <td>
                <div class="preview-item-name">{{line.name}}
                  <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                    Comment: <span>{{line.manual_pdf_comment}}</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="preview-item-value">
                  <span v-if="isEstimateMethodologyDollar || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                  <span v-else>{{line.hrs_str}}</span>
                </div>
              </td>
              <td>
                <div class="preview-item-value">
                  <span v-if="isEstimateMethodologyDollar || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                  <span v-else>{{line.rate_str}}</span>
                </div>
              </td>
              <td>
                <div class="preview-item-value preview-amount">{{line.total_str}}</div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] !=''">
              <td>
                <div class="preview-item-name preview-align-right">Subtotal Hrs</div>
              </td>
              <td>
                <div class="preview-item-name">{{estimateTo.line_items.summary["Repair-Hrs-SubTotal-Str"]}}</div>
              </td>
              <td>
                <div class="preview-item-name preview-align-right">Subtotal</div>
              </td>
              <td>
                <div class="preview-item-name  preview-amount">{{estimateTo.line_items.summary["Repair-Total-SubTotal-Str"]}}</div>
              </td>
            </tr>
          </tfoot>
        </table>
        <!--
        Repair without hours
         -->
        <table class="main-table estimate-parts border-t"  v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] ==''">
          <thead>
            <tr>
              <th colspan="8" style="padding-left: 15px;">Repair</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] ==''"
                v-for="line in estimateTo.line_items.lines.Repair">
              <td colspan="8">
                <div class="preview-item-name">{{line.name}}
                  <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                    Comment: <span>{{line.manual_pdf_comment}}</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="preview-item-value preview-amount">{{line.total_str}}</div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Repair.length && estimateTo.line_items.summary['Repair-Hrs-SubTotal-Str'] ==''">
              <td colspan="8">
                <div class="preview-item-name preview-align-right">Subtotal</div>
              </td>
              <td>
                <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Repair-Total-SubTotal-Str"]}}</div>
              </td>
            </tr>
          </tfoot>
        </table>
        <!--
       Delimiter
      -->
        <tr v-if="!!estimateTo.line_items.lines.Repair.length" class="nobrd">
          <td colspan="9">
            <div class="preview-delimiter"></div>
          </td>
        </tr>
        <!--
                                       Paint with hours
                                       -->
        <table class="main-table estimate-parts border-t" v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] !=''">
          <thead>
            <tr>
              <th style="padding-left: 15px;">Paint</th>
              <th style="padding-left: 15px;">
                <span v-if="isEstimateMethodologyDollar"></span>
                <span v-else>Hrs</span>
              </th>
              <th style="padding-left: 15px;">
                <span v-if="isEstimateMethodologyDollar"></span>
                <span v-else>Rate</span>
              </th>
              <th style="padding-left: 15px;">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] !=''"
                v-for="line in estimateTo.line_items.lines.Paint">
              <td>
                <div class="preview-item-name">{{line.name}}
                  <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                    Comment: <span>{{line.manual_pdf_comment}}</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="preview-item-value">
                  <span v-if="isEstimateMethodologyDollar || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                  <span v-else>{{line.hrs_str}}</span>
                </div>
              </td>
              <td>
                <div class="preview-item-value">
                  <span v-if="isEstimateMethodologyDollar || (line.hrs == 0 && line.rate == 0 && line.total != 0)"></span>
                  <span v-else>{{line.rate_str}}</span>
                </div>
              </td>
              <td>
                <div class="preview-item-value preview-amount">{{line.total_str}}</div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] !=''">
              <td>
                <div class="preview-item-name preview-align-right">Subtotal Hrs</div>
              </td>
              <td>
                <div class="preview-item-name">{{estimateTo.line_items.summary["Paint-Hrs-SubTotal-Str"]}}</div>
              </td>
              <td>
                <div class="preview-item-name preview-align-right">Subtotal</div>
              </td>
              <td>
                <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Paint-Total-SubTotal-Str"]}}</div>
              </td>
            </tr>
          </tfoot>
        </table>
        <!--
                                        Paint without hours
                                         -->

        <table class="main-table estimate-parts border-t" v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] ==''">
          <thead>
            <tr>
              <th colspan="8" style="padding-left: 15px;">Paint</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] ==''"
                v-for="line in estimateTo.line_items.lines.Paint">
              <td colspan="8">
                <div class="preview-item-name">{{line.name}}
                  <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                    Comment: <span>{{line.manual_pdf_comment}}</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="preview-item-value preview-amount">{{line.total_str}}</div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Paint.length && estimateTo.line_items.summary['Paint-Hrs-SubTotal-Str'] ==''">
              <td colspan="8">
                <div class="preview-item-name preview-align-right">Subtotal</div>
              </td>
              <td>
                <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Paint-Total-SubTotal-Str"]}}</div>
              </td>
            </tr>
          </tfoot>
        </table>


        <!--
        Labour
        -->
          <tr class="nobrd"
              v-if="(!!estimateTo.line_items.lines.Paint.length || !!estimateTo.line_items.lines.Repair.length || !!estimateTo.line_items.lines.RR.length) && estimateTo.line_items.summary['Labour-Hrs-Str'] != ''">
            <td colspan="8">
              <div class="preview-item-name preview-align-right">Total Labour Hours</div>
            </td>
            <td>
              <div class="preview-item-name">{{estimateTo.line_items.summary["Labour-Hrs-Str"]}}</div>
            </td>
          </tr>
          <tr class="nobrd"
              v-if="(!!estimateTo.line_items.lines.Paint.length || !!estimateTo.line_items.lines.Repair.length || !!estimateTo.line_items.lines.RR.length) && estimateTo.line_items.summary['Labour-Hrs-Str'] != ''">
            <td colspan="8">
              <div class="preview-item-name preview-align-right">Subtotal Amount</div>
            </td>
            <td>
              <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Labour-Cost-Str"]}}</div>
            </td>
          </tr>
          <tr class="nobrd"
              v-if="(!!estimateTo.line_items.lines.Paint.length || !!estimateTo.line_items.lines.Repair.length || !!estimateTo.line_items.lines.RR.length) && estimateTo.line_items.summary['Labour-Hrs-Str'] == ''">
            <td colspan="8">
              <div class="preview-item-name preview-align-right">Subtotal Amount</div>
            </td>
            <td>
              <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Labour-Cost-Str"]}}</div>
            </td>
          </tr>
        <!--
       Delimiter
      -->
        <tr v-if="!!estimateTo.line_items.lines.Paint.length" class="nobrd">
          <td colspan="9">
            <div class="preview-delimiter"></div>
          </td>
        </tr>
        <!--
         Parts
        -->
        <table class="main-table estimate-parts border-t" v-if="!!estimateTo.line_items.lines.Part.length">
          <thead class="th-fz12">
            <tr>
              <th>Parts</th>
              <th colspan="2">Part No</th>
              <th class="text-center">Qty</th>
              <th class="text-center">Unit Price</th>
              <th class="text-center">Amount</th>
            </tr>
          </thead>
          <tbody>
          <tr v-for="line in estimateTo.line_items.lines.Part">
            <td class="font-bold">{{ line.name }}
              <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                Comment: <span>{{ line.manual_pdf_comment }}</span>
              </div>
            </td>
            <td colspan="2" class="font-bold" style="word-break: break-all;">{{ line.part_num }}</td>
            <td class="font-bold text-center">{{ line.qty }}</td>
            <td class="text-right" style="font-weight: normal;">{{ line.rate_str }}</td>
            <td class="text-right" style="font-weight: normal;">{{ line.total_str }}</td>
          </tr>
          </tbody>
          <tfoot v-if="!!estimateTo.line_items.lines.Part.length">
            <tr class="parts-subtotal-hrs">
              <td></td>
             <td></td>
              <td></td>
              <td colspan="2" class="font-bold text-right">Subtotal Amount</td>
              <td class="text-right font-bold">{{ estimateTo.line_items.summary['Part-Total-SubTotal-Str'] }}</td>
            </tr>
          </tfoot>
        </table>

        <!--
        Delimiter
        -->
        <tr v-if="!!estimateTo.line_items.lines.Part.length" class="nobrd">
          <td colspan="9">
            <div class="preview-delimiter"></div>
          </td>
        </tr>
        <!--
        PDR
        -->
        <table class="main-table estimate-parts border-t" v-if="!!estimateTo.line_items.lines.PDR.length">
          <thead>
            <tr>
              <th>PDR</th>
              <th>Material</th>
              <th>Action</th>
              <th>Qty</th>
              <th>Price</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!!estimateTo.line_items.lines.PDR.length" v-for="line in estimateTo.line_items.lines.PDR">
              <td>
                <div class="preview-item-name">{{line.name}}
                  <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                    Comment: <span>{{line.manual_pdf_comment}}</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="preview-item-value">{{line.type === 'panel' ? line.material : ''}}</div>
              </td>
              <td>
                <div class="preview-item-value">{{line.type === 'panel' ? line.action : ''}}</div>
              </td>
              <td>
                <div class="preview-item-value">{{line.qty}}</div>
              </td>
              <td>
                <div class="preview-item-value">{{line.price}}</div>
              </td>
              <td>
                <div class="preview-item-value preview-amount">{{line.total_str}}</div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr v-if="!!estimateTo.line_items.lines.PDR.length" class="nobrd">
              <td>
                <div class="preview-item-name preview-align-right">Subtotal</div>
              </td>
              <td>
                <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["PDR-Total-SubTotal-Str"]}}</div>
              </td>
            </tr>
          </tfoot>
        </table>
        <!--
        Delimiter
        -->
        <tr v-if="!!estimateTo.line_items.lines.PDR.length" class="nobrd">
          <td colspan="9">
            <div class="preview-delimiter"></div>
          </td>
        </tr>
        <!--
        Materials
                -->
        <table class="main-table estimate-parts border-t" v-if="!!estimateTo.line_items.lines.Materials.length">
          <thead>
            <tr>
              <th>Materials</th>
              <th>Hrs</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!!estimateTo.line_items.lines.Materials.length" v-for="line in estimateTo.line_items.lines.Materials">
              <td>
                <div class="preview-item-name">{{line.name}}
                  <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                    Comment: <span>{{line.manual_pdf_comment}}</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="preview-item-value">{{line.hrs_str}}</div>
              </td>
              <td>
                <div class="preview-item-value preview-amount">{{line.total_str}}</div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Materials.length">
              <td>
                <div class="preview-item-name preview-align-right">Subtotal</div>
              </td>
              <td>
                <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Materials-Total-Str"]}}</div>
              </td>
            </tr>
          </tfoot>
        </table>
        <!--
        Delimiter
        -->
        <tr v-if="!!estimateTo.line_items.lines.Materials.length" class="nobrd">
          <td colspan="9">
            <div class="preview-delimiter"></div>
          </td>
        </tr>
        <!--
        Sublet with Hrs
       -->
        <table class="main-table estimate-parts border-t" v-if="!!estimateTo.line_items.lines.Materials.length">
          <thead>
            <tr>
              <th>Sublet</th>
              <th>Repairer</th>
              <th>Hrs</th>
              <th>Rate</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!!estimateTo.line_items.lines.Sublet.length && estimateTo.line_items.summary['Sublet-Hrs-SubTotal-Str'] !=''"
                v-for="line in estimateTo.line_items.lines.Sublet">
              <td>
                <div class="preview-item-name">{{line.name}}
                  <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                    Comment: <span>{{line.manual_pdf_comment}}</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="preview-item-value">{{line.repairer}}</div>
              </td>
              <td>
                <div class="preview-item-value">{{line.hrs_str}}</div>
              </td>
              <td>
                <div class="preview-item-value">{{line.rate_str}}</div>
              </td>
              <td>
                <div class="preview-item-value preview-amount">{{line.total_str}}</div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Sublet.length && estimateTo.line_items.summary['Sublet-Hrs-SubTotal-Str'] != ''">
              <td>
                <div class="preview-item-name preview-align-right">Subtotal Hrs</div>
              </td>
              <td>
                <div class="preview-item-name preview-align-right">{{estimateTo.line_items.summary["Sublet-Hrs-SubTotal-Str"]}}</div>
              </td>
              <td>
                <div class="preview-item-name preview-align-right">Subtotal</div>
              </td>
              <td>
                <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Sublet-Total-SubTotal-Str"]}}</div>
              </td>
            </tr>
          </tfoot>
        </table>
        <!--
       Sublet without Hrs
      -->
        <table class="main-table estimate-parts border-t" v-if="!!estimateTo.line_items.lines.Sublet.length && estimateTo.line_items.summary['Sublet-Hrs-SubTotal-Str'] ==''">
          <thead>
            <tr>
              <th>Sublet</th>
              <th>Repairer</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!!estimateTo.line_items.lines.Sublet.length && estimateTo.line_items.summary['Sublet-Hrs-SubTotal-Str'] ==''"
                v-for="line in estimateTo.line_items.lines.Sublet">
              <td>
                <div class="preview-item-name">{{line.name}}
                  <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                    Comment: <span>{{line.manual_pdf_comment}}</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="preview-item-value">{{line.repairer}}</div>
              </td>
              <td>
                <div class="preview-item-value"></div>
              </td>
              <td>
                <div class="preview-item-value"></div>
              </td>
              <td>
                <div class="preview-item-value preview-amount">{{line.total_str}}</div>
              </td>
            </tr>
          </tbody>
          <tfoot>
          <tr v-if="!!estimateTo.line_items.lines.Sublet.length && estimateTo.line_items.summary['Sublet-Hrs-SubTotal-Str'] == ''" class="nobrd">
            <td>
              <div class="preview-item-name preview-align-right">Subtotal</div>
            </td>
            <td>
              <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Sublet-Total-SubTotal-Str"]}}</div>
            </td>
          </tr>
          </tfoot>
        </table>
        <!--
       Delimiter
      -->
        <tr v-if="!!estimateTo.line_items.lines.Sublet.length" class="nobrd">
          <td colspan="9">
            <div class="preview-delimiter"></div>
          </td>
        </tr>
        <!--
         Other
        -->
          <table class="main-table estimate-parts border-t" v-if="!!estimateTo.line_items.lines.Other.length">
            <thead class="th-fz12">
              <tr>
                <th colspan="8" style="padding-left: 15px;">Other</th>
                <th style="padding-left: 15px;">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!!estimateTo.line_items.lines.Other.length" v-for="line in estimateTo.line_items.lines.Other">
                <td colspan="8">
                  <div class="preview-item-name">{{line.name}}
                    <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                      Comment: <span>{{line.manual_pdf_comment}}</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="preview-item-value preview-amount">{{line.total_str}}</div>
                </td>
              </tr>
            </tbody>
            <tfoot v-if="!!estimateTo.line_items.lines.Part.length">
              <tr class="nobrd" v-if="!!estimateTo.line_items.lines.Other.length">
                <td colspan="8">
                  <div class="preview-item-name preview-align-right">Subtotal</div>
                </td>
                <td>
                  <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Other-Total-SubTotal-Str"]}}</div>
                </td>
              </tr>
            </tfoot>
          </table>
        <!--
        Total
        -->
        <table class="main-table estimate-parts border-t">
          <tr v-if="countSubtotal > 1" class="nobrd">
            <td colspan="8">
              <div class="preview-item-name preview-align-right">Total</div>
            </td>
            <td>
              <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary["Total_str"]}}</div>
            </td>
          </tr>
          <tr class="nobrd">
            <td colspan="8">
              <div class="preview-item-name preview-align-right">GST</div>
            </td>
            <td>
              <div class="preview-item-name preview-amount">{{estimateTo.line_items.summary.GST_str}}</div>
            </td>
          </tr>
          <tr class="nobrd">
            <td colspan="7">
              <div class="preview-item-name preview-align-right"></div>
            </td>
            <td colspan="">
              <div class="preview-item-name preview-align-right"
                   style="border-top: 1px solid rgba(27, 30, 56, 0.25) !important;margin-left: 45px; padding-left: 0px;
">Total Inc GST
              </div>
            </td>
            <td>
              <div class="preview-item-name preview-amount"
                   style="border-top:1px solid rgba(27,30,56,0.25) !important; position: relative;"
              >{{estimateTo.line_items.summary.GrandTotal_str}}
                <div class="preview-total-plus"></div>
              </div>

            </td>
          </tr>
          <tr class="nobrd">
            <td colspan="9">
              <div class="preview-terms-delimeter"></div>
            </td>
          </tr>
        </table>
        <template v-if="estimateTo?.note_terms != '' && estimateTo?.terms != ''">
          <tr class="nobrd">
            <td colspan="9">
              <table style="width: 100%">
                <tr>
                  <td style="width: 50%; padding-right: 5px; border: none">
                    <div class="border-td">
                      <div class="preview-terms-header">Terms</div>
                      <div class="preview-terms" v-html="estimateTo.terms"></div>
                    </div>
                  </td>
                  <td style="width: 50%; padding-left: 5px; border: none">
                    <div class="border-td">
                      <div class="preview-terms-header">Estimate Note</div>
                      <div class="preview-terms" v-html="estimateTo?.note_terms"></div>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </template>
        <template v-else-if="estimateTo?.terms != ''">
          <tr class="nobrd">
            <td colspan="9">
              <table style="width: 100%">
                <tr>
                  <td style=" border: none">
                    <div class="border-td">
                      <div class="preview-terms-header">Terms</div>
                      <div class="preview-terms" v-html="estimateTo?.terms"></div>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </template>
        <template v-else-if="estimateTo?.note_terms">
          <tr class="nobrd">
            <td colspan="9">
              <table style="width: 100%">
                <tr>
                  <td style=" border: none">
                    <div class="border-td">
                      <div class="preview-terms-header">Estimate Note</div>
                      <div class="preview-terms" v-html="estimateTo?.note_terms"></div>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr class="nobrd">
            <td colspan="9">
            </td>
          </tr>
        </template>
      </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import { isMobile } from '@/deviceDetect/index'

export default {
        name: 'estimate-preview',
        props: ['estimateTo', 'isEstimateMethodologyCustom', 'isEstimateMethodologyDollar', 'isHideGST'],
        data: function () {
            return {
              isMobile,
            };
        },
        computed: {
            ...mapGetters([
                'vendorInfo',
                'isVendorBranding',
                'getVendorBrandingType',
                'isShowJobTypeCash',
            ]),
            isVendorBrandingType1() {
              return this.isVendorBranding && this.getVendorBrandingType == 'type1'
            },
            isVendorBrandingType3() {
              return this.isVendorBranding && this.getVendorBrandingType == 'type3'
            },
            isVendorBrandingType2() {
              return this.isVendorBranding && this.getVendorBrandingType == 'type2'
            },
            countSubtotal() {
                let countSubtotal = 0;
                if (this.estimateTo && this.estimateTo.line_items && this.estimateTo.line_items.lines) {
                    _.forEach(this.estimateTo.line_items.lines, function (i) {
                        if (i.length > 0) {
                            countSubtotal++;
                        }
                    });
                }
                return countSubtotal;
            }
        },
        methods:{
            isEmpty(val){
                return _.isEmpty(val);
            },
        },
    };
</script>
<style scoped>
.border-td {
   border: 1px solid silver;
   border-radius: 10px;
   padding: 10px;
   min-height: 100px;
}
.border-td.margin-right {
    margin-right: 10px;
}
.table-preview-mobile .preview-item-name,
.table-preview-mobile .preview-item-value{
  padding: 5px 15px;
}
.table-preview-mobile .preview-logo img{
  width: 100%;
  object-fit: contain;
  height: auto;
}
.estimate-preview-mobile{
  min-width: auto;
}
.estimate-preview-mobile .preview-item-name{
  padding: 5px;
}
.main-table.estimate-parts tbody tr{
  border-bottom: 2px solid rgba(27, 30, 56, 0.1);
}
</style>

<style>
.V3 .estimate-preview.branding-type1 {
  font-family: 'Roboto', sans-serif !important;
}

.V3 .estimate-preview.branding-type2 {
  font-family: "Montserrat", sans-serif !important;
}

.V3 .estimate-preview.branding-type3 {
  font-family: "Work Sans", sans-serif !important;
}

.V3 .estimate-preview.branding-type1 .preview-header-title,
.V3 .estimate-preview.branding-type2 .preview-header-title {
  font-weight: 900 !important;
}

.V3 .estimate-preview.branding-type1 .preview-head-name,
.V3 .estimate-preview.branding-type1 .preview-subhead-name,
.V3 .estimate-preview.branding-type2 .preview-head-name,
.V3 .estimate-preview.branding-type2 .preview-subhead-name {
  color: black;
  font-weight: 500 !important;
}

.V3 .estimate-preview.branding-type1 .preview-item-name,
.V3 .estimate-preview.branding-type2 .preview-item-name {
  font-weight: 400 !important;
}

.V3 .estimate-preview.branding-type2 .preview-head-name,
.V3 .estimate-preview.branding-type2 .preview-subhead-name {
  color: white !important;
  background-color: #A9A9A9 !important;
}
.V3 .estimate-preview.branding-type2 .preview-subhead-name span {
  color: white !important;
}

.V3 .estimate-preview.branding-type3 .preview-head-name,
.V3 .estimate-preview.branding-type3 .preview-subhead-name {
  color: white !important;
  background-color: #3a3a3a !important;
}
.V3 .estimate-preview.branding-type3 .preview-subhead-name span {
  color: white !important;
}

</style>
